const NotPaid = () => {
    return ( <div>
        <div className="d-flex  justify-content-center align-items-center">
            <div className="card bg-primary w-75" style={{
            height:"80vh"
        }}>
            <div className="h-100 d-flex align-items-center justify-content-center">
                <div>
            <h5 className="display-6 m-4 text-light">Your company has not completed their payment</h5>
            <h5 className="display-6 m-4 text-light">Email <a className="text-light" href="mailto:luyanda@thepeople.co.za" style={{
                color:"white"
            }}>luyanda@thepeople.co.za</a></h5>
            

                </div>
            </div>
        </div>
        </div>
        
    </div> );
}
 
export default NotPaid;